export interface ProductDetailMetric {
  label: string;
  value: number | null | undefined;
}

export function isMeaningfulProductPercent(
  value: number | null | undefined,
): value is number {
  return value != null && Number.isFinite(value);
}

/**
 * Arrange populated cannabinoids into full/pair rows. THC is expected first.
 * An odd count leaves the first cannabinoid full-width; even counts pair all.
 */
export function buildCannabinoidRows(
  values: readonly ProductDetailMetric[],
): ProductDetailMetric[][] {
  const populated = values.filter((metric) =>
    isMeaningfulProductPercent(metric.value),
  );
  if (populated.length === 0) return [];

  const rows: ProductDetailMetric[][] = [];
  let index = 0;
  if (populated.length % 2 === 1) {
    rows.push([populated[0]!]);
    index = 1;
  }
  while (index < populated.length) {
    rows.push(populated.slice(index, index + 2));
    index += 2;
  }
  return rows;
}

export function shouldShowSetPrimary(
  isPrimary: boolean,
  editableImageCount: number,
): boolean {
  return editableImageCount > 1 && !isPrimary;
}
